import axios from "axios";

const isDev = process.env.REACT_APP_DEV === "true";

const customAxios = axios.create({
    baseURL: isDev ? "http://localhost:52678" : "https://anvil.team"
});

let token = localStorage.getItem("token");

if (token) {
    customAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`; 
}

export default customAxios;